import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../api";
import "./login.css";

import Input from "../../components/input/input";
import Button from "../../components/button/button";

import logo from "./img/logo.svg";

const LogIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validateEmail = (val) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    if (!emailPattern.test(val)) {
      return "Please enter a valid email address.";
    }
    return null;
  };

  const validatePassword = (val) => {
    if (val.length < 6) {
      return "Password must be at least 6 characters long.";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    if (validateEmail(email)) {
      isValid = false;
    }
    if (validatePassword(password)) {
      isValid = false;
    }

    if (!isValid) {
      setError("Something went wrong");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const response = await api.post("/api/login", {
        email,
        password,
        recaptcha: null,
      });

      const { token, user_id } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user_id", user_id);

      navigate("/deposit-history");
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError("Invalid email or password.");
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const isButtonDisabled = !email || !password || loading;

  return (
    <div className="loginContainer">
      <div className="loginFormWrap">
        <div className="loginForm">
          <div className="loginFormTitle">Admin</div>
          <img className="loginFormLogo" src={logo} alt="logo" />
          <form>
            <Input
              label="Email address"
              id="email"
              type="email"
              value={email}
              onChange={(val) => setEmail(val)}
              validate={(val) => validateEmail(val)}
            />
            <Input
              label="Password"
              id="password"
              type="password"
              value={password}
              onChange={(val) => setPassword(val)}
              validate={(val) => validatePassword(val)}
            />
            <Button
              className="loginBtn"
              type="submit"
              text="Log In"
              onClick={handleSubmit}
              disabled={isButtonDisabled}
              loading={loading}
            />
            {error && <div className="error">{error}</div>}
          </form>
          <div className="bottomText">
            Don’t have an account? <Link>Register</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
